export const trackedMetrics = [
  { id: "numberOfActiveUnitsInWallet", label: "numberOfActiveUnitsInWallet" },
  { id: "totalEarnedUnitsInWallet", label: "totalEarnedUnitsInWallet" },
  { id: "customMetric", label: "customMetric" },
];
